import { parseQueryString } from '../../utils/utils';

export let essParams = {
  isFromEss: false,
  isNoChangeFromESS: false,
  surveyResults: null,
  eventData: {}
};

export const recordEssParams = () => {
  const params = parseQueryString();

  if (params.source_id !== 'emp_xp') return;

  essParams = {
    isFromEss: true,
    isNoChangeFromESS: params.no_change === 'true',
    surveyResults: null,
    latitude: Number(params.latitude),
    longitude: Number(params.longitude),
    eventData: {
      source_relation: params.source_relation,
      source_user_relation_id: params.source_user_relation_id,
      source_age_years: params.source_age_years,
      source_gender: params.source_gender
    }
  };
};

export const saveSurveyResults = surveyResults => {
  essParams.surveyResults = surveyResults;
};

export const ess = () => Object.freeze({ ...essParams });
